export const collapsibleText = () => {
  const collapsibleText = document.querySelector(".js-collapsible-text");
  const collapsibleTextContent = document.querySelector(
    ".js-collapsible-text-content"
  );
  let collapsibleHeight;
  const collapsibleTextToggle = document.querySelector(
    ".js-collapsible-text-toggle"
  );
  // const collapsibleTextToggle = ".js-collapsible-text-toggle";
  const maxHeight = "15em";

  let collapsibleTextTotalHeight = 0;

  const init = () => {
    bind();
    calcHeight();
  };

  const bind = () => {
    collapsibleTextToggle.onclick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      // var closestCollapsible = this.closest(collapsibleText);

      collapsibleText.getAttribute("data-state") == "closed"
        ? collapsibleText.setAttribute("data-state", "open")
        : collapsibleText.setAttribute("data-state", "closed");

      if (collapsibleText.getAttribute("data-state") == "open") {
        collapsibleHeight = collapsibleTextContent.offsetHeight;
        collapsibleText.style.maxHeight = collapsibleHeight + "px";
        collapsibleText.classList.remove("has-gradient");
      } else {
        collapsibleText.style.maxHeight = "15em";
        collapsibleText.classList.add("has-gradient");
      }
    };

    // window.addEventListener("resize", calcHeight);
  };

  const calcHeight = () => {
    // collapsibleTextTotalHeight = 0;
    // $(".js-collapsible-text .js-collapsible-text-content").each(function () {
    //   collapsibleTextTotalHeight =
    //     collapsibleTextTotalHeight + $(this).outerHeight(true);
    // });
    // $('.js-collapsible-text[data-state="open"]').css({ "max-height": 9999 });
  };

  if (typeof collapsibleText != "undefined" && collapsibleText != null) {
    init();
  }
};
